<template>
  <modal
    disable-close-backdrop
    title="Add Cards to Watchlist"
    :open="open"
    @close="closeModal"
  >
    <card-search
      placeholder="Search for a card"
      :exclude-ids="cardIds"
      @select="addCard"
    />

    <br />

    <div
      v-for="card in cards"
      :key="card.id"
      class="card-item"
    >
      <align no-gap>
        <icon-button
          icon="close"
          @click="removeCard(card.cardId)"
        />

        <card-list-item :card="card" :fields="['currentValue']" />
      </align>
    </div>

    <div class="action">
      <btn
        loading-text="Adding"
        :loading="saving"
        :disabled="disabled"
        @click="submit"
      >
        Add to Watchlist
      </btn>
    </div>
  </modal>
</template>

<script>
import { mapState } from 'vuex';
import * as Sentry from '@sentry/vue';

import { cardService, authService } from '@/services';
import { constructWatchCard } from '@cardladder/shared/utils/watchlist.util';

import CardSearch from '@/cards/CardSearch';
import CardListItem from '@cardladder/shared/components/CardListItem';

export default {
  components: {
    CardSearch,
    CardListItem,
  },

  props: {
    open: Boolean,
  },

  data() {
    return {
      cards: [],
      saving: false,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.user,
    }),

    disabled() {
      return this.cards.length === 0;
    },

    cardIds() {
      return this.cards.map(({ cardId }) => cardId);
    },
  },

  methods: {
    async submit() {
      this.saving = true;

      try {
        for (let i = 0; i < this.cards.length; i += 1) {
          await authService.addToWatchlist(this.user.uid, this.cards[i]);
        }

        this.$bus.$emit('watchlist-changed', { add: true });
        this.$toasted.success('Added to your watchlist!');
        this.closeModal();
      } catch (e) {
        this.$toasted.error('Error saving the card');
        Sentry.captureException(e);
      }

      this.saving = false;
    },

    async addCard({ id }) {
      try {
        const card = await cardService.getCard(id);
        const watchCard = constructWatchCard(this.user.uid, card);

        this.cards.push(watchCard);
      } catch (e) {
        this.$toasted.error('Error loading the card');
        Sentry.captureException(e);
      }
    },

    removeCard(cardId) {
      this.cards = this.cards.filter(({ cardId: id }) => id !== cardId);
    },

    closeModal() {
      this.reset();
      this.$emit('close');
    },

    reset() {
      this.cards = [];
      this.saving = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-item {
  margin-bottom: $gp * .5;
}

.action {
  margin-top: $gp;
}
</style>
